<template>
  <el-dialog
    title="删除应用"
    :visible.sync="visible"
    width="400px"
  >
    <p>确定要删除该应用吗？</p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="danger" @click="handleDelete">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteOpenApiApp } from '@/api/system/openApiAuthApi'

export default {
  name: 'DeleteOpenApiApp',
  data() {
    return {
      visible: false,
      appId: ''
    }
  },
  methods: {
    open(app) {
      this.appId = app.appId
      this.visible = true
    },
    async handleDelete() {
      try {
        await deleteOpenApiApp({ appId: this.appId })
        this.$message.success('删除成功')
        this.$emit('success')
        this.visible = false
      } catch (error) {
        this.$message.error('删除失败')
      }
    }
  }
}
</script>